<template>
  <content-page back>
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">
        IRS Certification
      </div>
    </template>

    <div class="pa-2 white legal">

      <p>
        Under penalties of perjury, I certify that: 1. The number shown on this form
        is my correct taxpayer identification number (or I am waiting for a number
        to be issued to me); and 2. I am not subject to backup withholding because:
        (a) I am exempt from backup withholding, or (b) I have not been notified by
        the Internal Revenue Service (IRS) that I am subject to backup withholding as
        a result of a failure to report all interest or dividends, or (c) the IRS
        has notified me that I am no longer subject to backup withholding; and 3. I
        am a U.S. citizen or other U.S. person (defined below); and 4. The FATCA
        code(s) entered on this form (if any) indicating that I am exempt from FATCA
        reporting is correct.
      </p>
    </div>

  </content-page>
</template>

<script>
  import { ContentPage } from '@/components/pages'

  export default {
    components: { ContentPage },
  }
</script>